import { ORG_EXTENSION_FILTERABLE_FIELDS } from '@kirin/api-client/contracts/extensions';
import type { OrgExtensionFilterableField } from '@kirin/api-client/contracts/extensions';

export const ORG_EXTENSION_TABLE_CONFIG = {
  tableId: 'org-ext',
  defaultOperator: 'includes',
} as const;

export const ORG_EXTENSION_FILTER_URL_KEYS = {
  [ORG_EXTENSION_FILTERABLE_FIELDS.NAME]: 'en',
  [ORG_EXTENSION_FILTERABLE_FIELDS.PUBLISHER]: 'ep',
  [ORG_EXTENSION_FILTERABLE_FIELDS.SOURCE]: 'es',
  [ORG_EXTENSION_FILTERABLE_FIELDS.IDE]: 'ei',
  [ORG_EXTENSION_FILTERABLE_FIELDS.FIRST_SEEN_AT]: 'efs',
  [ORG_EXTENSION_FILTERABLE_FIELDS.LAST_SEEN_AT]: 'els',
  [ORG_EXTENSION_FILTERABLE_FIELDS.USER]: 'eu',
  [ORG_EXTENSION_FILTERABLE_FIELDS.SECURITY]: 'esec',
  [ORG_EXTENSION_FILTERABLE_FIELDS.RISK_ESTIMATE]: 'erisk',
  [ORG_EXTENSION_FILTERABLE_FIELDS.SCAN_STATUS]: 'escan',
} as const satisfies Record<OrgExtensionFilterableField, string>;

export {
  EXTENSION_SOURCE_OPTIONS,
  EXTENSION_FILTER_OPTIONS_PAGE_SIZE,
} from '../DataTableExtensionsTab/constants';
